import { ApiUpdateAccountPasswordRequest } from '../interfaces/api-update-account-password.request';

export function mapUpdateAccountPasswordRequest(password: string): ApiUpdateAccountPasswordRequest {
    return {
        password: password,
    };
}
